import { Stack, Typography } from "@mui/material";
import {
  PrimaryInfoAlert,
  PrimaryLinkApplicationCard,
  StyledButton,
} from "react-common-ui-library";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  ACCOUNT_CREATION_ROUTE,
  CONTAINED,
  LINK_APPLICATION_ROUTE,
  NAME_AND_CONTACT_ROUTE,
  TEXT,
} from "../../../Constants/CommonConstants";
import {
  LINK_RESULTS_ALERT_TEXT,
  LINK_RESULTS_ALERT_TITLE,
  LINK_RESULTS_CANCEL_BUTTON,
  LINK_RESULTS_CREATE_BUTTON,
  RESULT_HAP_CARD_ALERT,
} from "../../../Constants/LinkMyApplicationConstants";
import { manageLinkApplicationSelector } from "../../../Selectors/LinkApplicationSelector";
import { StyledLinkApplicationSubmitButtonBox } from "../../../Styles/LinkApplication/LinkMyApplication";

/**
 * @description Results Hap Card screen allows the user view the hap number and name with an alert
 * @returns {ReactNode} Renders the Link Application Results Screen which has the hapId, name and alert component
 */
export const ResultsHapCard = () => {
  const intl = useIntl();

  const navigate = useNavigate();

  const { responseDataFirstName, responseDataLastName, responseDataHapId } =
    useSelector((state) => manageLinkApplicationSelector(state));

  const fullNameConstruct = () => {
    if (!responseDataFirstName || !responseDataLastName) {
      return "";
    }
    return `${responseDataFirstName} ${responseDataLastName}`;
  };

  const onCreateClickHandler = () => {
    navigate(`/${ACCOUNT_CREATION_ROUTE}/${NAME_AND_CONTACT_ROUTE}`);
  };

  const onCancelClickHandler = () => {
    navigate(`/${LINK_APPLICATION_ROUTE}`);
  };

  return (
    <Stack spacing={{ xs: 6, md: 5 }}>
      <PrimaryLinkApplicationCard
        name={fullNameConstruct()}
        hapId={responseDataHapId}
      />
      <Stack spacing={{ xs: 7, md: 10 }}>
        <PrimaryInfoAlert
          id={RESULT_HAP_CARD_ALERT}
          title={intl.formatMessage({ id: LINK_RESULTS_ALERT_TITLE })}
          content={
            <Typography id={LINK_RESULTS_ALERT_TEXT}>
              {intl.formatMessage({ id: LINK_RESULTS_ALERT_TEXT })}
            </Typography>
          }
        />
        <Stack spacing={3}>
          <StyledLinkApplicationSubmitButtonBox>
            <StyledButton
              id={LINK_RESULTS_CREATE_BUTTON}
              onClick={onCreateClickHandler}
              variant={CONTAINED}
            >
              {intl.formatMessage({ id: LINK_RESULTS_CREATE_BUTTON })}
            </StyledButton>
          </StyledLinkApplicationSubmitButtonBox>
          <StyledLinkApplicationSubmitButtonBox>
            <StyledButton
              id={LINK_RESULTS_CANCEL_BUTTON}
              onClick={onCancelClickHandler}
              variant={TEXT}
            >
              {intl.formatMessage({ id: LINK_RESULTS_CANCEL_BUTTON })}
            </StyledButton>
          </StyledLinkApplicationSubmitButtonBox>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ResultsHapCard;
